import apiUrl from './config.url.js'
export default {
	isProduction: process.env.NODE_ENV === 'production',
	jobApiUrl : {
		// href : 'https://jobs.race.id/api/',
		// href : 'http://localhost:9922/api/',
		href : apiUrl.jobApiUrl.href,
		apis : {
			idValidation : {
				path : 'doValidateID',
				method : 'POST'
			},
			checkValidation : {
				path : 'checkValidation',
				method : 'POST'
			},
			sendMail : {
				path : 'sendMail',
				method : 'POST'
			}
		}
	},
	apiUrl : {
		// href : 'https://www.steelytoe.com/dev.titudev.com/api/v1/'
		// href : 'https://my.borobudurmarathon.com/dev.titudev.com/api/v1/',
		href : apiUrl.steelytoeUrl.href,
		apis : {
			member : {			
				/*
					{
						"data": {
							"ptmmFullName": "Thomas Hendri Hananto",
							"ptmmEmail": "foxdove02@gmail.com",
							"ptmmPhone": "085329688884",
							"ptmmGender": 1,
							"ptmmPassword": "sa"
						}
					}
				*/
				signup : {
					path : 'member/signup/1/',
					method : 'POST'
				},
				cancel : {
					path : 'member/cancel/',
					method : 'GET'					
				},
				verification : {
					path : 'member/verification/',
					method : 'GET'					
				},
				// {"data":{"email":"thomas.rubhez@gmail.com","password":"sa"}}
				login : {
					path : 'member/login/',
					method : 'POST'					
				},
				checkSession : {
					path : 'member/check/',
					method : 'GET'					
				},
				logout : {
					path : 'member/logout/',
					method : 'GET'					
				},
				checkEmail : {
					path : 'member/email/1/',
					method : 'POST'
				},
				setupPassword : {
					path : 'member/setup_password/',
					method : 'POST'
				},
				rejectInvitation : {
					path : 'global/delete_member/',
					method : 'GET'
				},
				/*
					{
						"data": {
							"email": "foxdove02@gmail.com"
						}
					}
				*/
				resendCode : {
					path : 'member/resentcode/1/',
					method : 'POST'
				},
				//{"data":{"email":"thomas.rubhez@gmail.com"}}
				setProfile : {
					path : 'member_zone/detail/',
					method : 'POST'
				},
				agreeNews : {
					path : 'member_zone/newsletter/',
					method : 'GET'
				},
				changeProfile : {
					path : 'member_zone/data_unverified/',
					method : 'GET'
				},
				setLanguage : {
					path : 'member_zone/language/',
					method : 'GET'
				},
				// {"data":{"email":"thomas.rubhez@gmail.com"}}
				resetPassword : {
					path : 'member/forgot_password',
					method : 'POST'
				},
				/*
					{
						"data": {
							"mbsdIDNumberType": 1,
							"mbsdIDNumber": "000111",
							"mbsdBirthDate": "1991-02-25",
							"mbsdBirthPlace": "Kebumen",
							"mbsdNationality": "Indonesia",
							"mbsdCountry": "Indonesia",
							"mbsdProvinces": "Jawa Tengah",
							"mbsdCity": "Gombong",
							"mbsdAddress": "Jln Yos Sudarso no 284",
							"mbsdRawAddress": "dasdsadasdasdasdasdasdsadsadsadasdsa",
							"mbsdFile": "thomas.jpg"
						}
					}
				*/
				addPhone : {
					path : 'member_zone/phone/',
					method : 'POST'
				},
				/*
					{
						"data": {
							"mbspCountryCode": "+62",
							"mbspNumber": "85329688884"
						}
					}
				*/
				getProfile : {
					path : 'member_resource/member/',
					method : 'GET'
				},
				verifyPhone : {
					path : 'member_zone/phone_verification/',
					method : 'GET'
				},
				registerEvent : {
					path : 'member_zone/registration/',
					method : 'POST'
				},
				registerFastRunner : {
					path : 'member_zone/registration_fr/',
					// path : 'member_zone/fastrunner/',
					method : 'POST'
				},
				getTransaction : {
					path : 'member_zone/transaction/',
					method : 'GET'
				},
				checkout : {
					path : 'checkout/',
					method : 'GET'
				},
				// data validation
				updateProfile : {
					path : 'member_zone/data_unverified/',
					method : 'GET'
				},
				// Ballot approval
				rejectFastRunner : {
					path : 'member_zone/switchedregis/', //#refId
					method : 'GET'
				},
				approveBallot : {
					// path : 'member_zone/approved_ballot/', //#refId
					path : 'member_zone/approved_ballot_saveduit/', //#refId
					method : 'GET'
				},
				verifyData : {
					path : 'member_zone/data_verification/',
					method : 'GET'
				},
				// data {"data":{"password":"aa","confirmPassword":"aa"}}
				newPassword : {
					// path : 'member/password_verification/{mfpaCode}/{mfpaUniqueKey}',
					path : 'member/password_verification/',
					method : 'POST'
				}
			}
		},
		resources : {
			masterKabupaten : {
				path : 'resources/master_kabupaten',
			},
			lokerTransaction : {
				path : 'resources/loker_transaction',
			},
			event_participant : {
				path : 'resources/member_bormar_data',
			}
		}
	},
	validatorUrl : {
		// href : 'https://validator.race.id/',
		href : apiUrl.validatorUrl.href,
		apis : {
			upload : {
				path :  'upload/'
			},
			extract : {
				path : 'extract/image/'
			}
		}
	},
	utilityUrl : {
		href : apiUrl.utilityUrl.href,
		// href : 'https://utilities.race.id/file/',
		// href : 'http://localhost:8082/',
		apis : {
			upload : {
				path : 'upload/'
			}
		}
	},
	adminUrl : {
		href : apiUrl.steelytoeUrl.href,
		apis : {
			user : {				
				login : {
					path : 'rm/login/',
					method : 'POST'					
				},
				checkSession : {
					path : 'rm/check/',
					method : 'GET'					
				},
				logout : {
					path : 'rm/logout/',
					method : 'GET'					
				},
			},
			member : {
				path : 'rm/view/member/',
				method : 'GET'
			},
			members : {
				path : 'rm/view/member_data',
				method : 'GET'
			},
			/*
				EDIT DATA MEMBER
				API : api/v1/member_zone/update_detail
				DATA : {"data":{"mdupMbsdId":"77333","mdupFullName":"alfian Christianto","mdupGender":"1","mdupBloodType":"0","mdupBirthPlace":"jakarta","mdupBirthDate":"1991-12-29","mdupNationality":"Indonesian","mdupCountry":"Indonesia","mdupProvinces":"DKI JAKARTA","mdupCity":"KOTA ADM. JAKARTA BARAT","mdupAddress":"Mangga Besar, Taman Sari, KOTA ADM. JAKARTA BARAT, DKI JAKARTA","mbsdStatus":"1","mdupUserUpdate":"thomas.rubhez@gmail.com"}}			
			*/
			memberUpdate : {
				path : 'member_zone/update_detail',
				method : 'POST'
			},
			approval : {
				ballot : {
					path : 'member_zone/approved_ballot/',
					method : 'GET'
				}
			},
			registrations : {
				path : 'rm/view/registrasi',
				method : 'GET'
			}				
		}
	}
};



// WEBPACK FOOTER //
// src/config.js